$('.btn-search-panel').on('click', function (e) {
    e.preventDefault();
    $('.search__area').toggleClass('open');
});